/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'
import Modal from '../../../components/Modal'


/*
 * Props
 *
 * show
 * primaryBtnPressed
 * ghostBtnPressed
 */

export default class MissingOpponent extends Component {

    render() {

        return (
            <div className ="MissingOpponent">
                <Modal title="Missing Opponent" open={this.props.show} hideCloseBtn={true}>
                    <div className="content">
                        <p>
                        Are you sure you want to continue without adding an opponent name?
                        </p>
                    </div>
                    <div className="buttons">
                        <button type="button" className="trace-input" onClick={this.props.primaryBtnPressed}>No, I&apos;ll fix it</button>
                    </div>
                    <div className="buttons">
                        <button type="button" className="trace-input ghost" onClick={this.props.ghostBtnPressed}>Yes, continue</button>
                    </div>
                </Modal>
            </div>
        )
    }    
}
